'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

export class UiComponent {
  constructor(domEl){
    const pv = privateMap(this);
    pv.domEl = domEl;
    pv.focused = false;
    pv.visible = true;
    pv.active = true;
    pv.focusedClassName = 'focused';
    pv.componentAry = [];
  }

  get domEl(){
    const pv = privateMap(this);
    return pv.domEl;
  }

  addComponent(component){
    const pv = privateMap(this);
    pv.componentAry.push(component);
    component.applySize();
  }
  
  removeComponent(component){
    const pv = privateMap(this);
    util.arrayRemove(pv.componentAry, component);
    domUtil.detach(component.domEl);
  }

  focus(){
    const pv = privateMap(this);
    if (pv.focused) {
      return;
    }
    pv.focused = true;
    pv.domEl.className += ' ' + pv.focusedClassName;
    domUtil.dispatchEvent(pv.domEl, 'ui.focus');
  }

  blur(){
    const pv = privateMap(this);
    if (!pv.focused || !pv.domEl.className) {
      return;
    }
    pv.focused = false;
    pv.domEl.className = util.arrayRemove(pv.domEl.className.split(/\s+/), pv.focusedClassName).join(' ');
    domUtil.dispatchEvent(pv.domEl, 'ui.blur');
  }

  get active(){
    return privateMap(this).active;
  }

  set active(flag){
    const pv = privateMap(this);
    if (pv.active == flag) {
      return;
    }
    pv.active = flag;
    if (pv.active && pv.visible) {
      domUtil.setStyle(pv.domEl, 'display', '');
      this.applySize();
    } else {
      domUtil.setStyle(pv.domEl, 'display', 'none');
    }
    domUtil.dispatchEvent(pv.domEl, 'ui.active', {detail: {active: flag}});
  }

  get visible(){
    const pv = privateMap(this);
    return pv.visible;
  }

  set visible(flag){
    const pv = privateMap(this);
    if (pv.visible == flag) {
      return;
    }
    pv.visible = flag;
    domUtil.setStyle(pv.domEl, 'display', pv.active && pv.visible ? '' : 'none');
    domUtil.dispatchEvent(pv.domEl, 'ui.visible', {detail: {visible: flag}});
  }

  applySize(){
    const pv = privateMap(this);
    util.each(pv.componentAry, function(component){
      component.applySize();
    });
  }
};
